import { render, staticRenderFns } from "./ChartCompletionRatio.vue?vue&type=template&id=0b130c21&scoped=true"
import script from "./ChartCompletionRatio.vue?vue&type=script&lang=js"
export * from "./ChartCompletionRatio.vue?vue&type=script&lang=js"
import style0 from "./ChartCompletionRatio.vue?vue&type=style&index=0&id=0b130c21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b130c21",
  null
  
)

export default component.exports